import sdk from './src/sdk';

window.Realeyesit = window.Realeyesit || {};
window.Realeyesit.Collection = window.Realeyesit.Collection || {};
window.Realeyesit.Collection.SDK = sdk;

export default window.Realeyesit.Collection.SDK;
